import React, { useCallback, useEffect, useState } from 'react'
import TableCustom from '../../../components/table/tableCustom';
import InputTextField from '../../../components/input/inputTextField';
import { FiberManualRecord, RemoveRedEyeOutlined, SearchOutlined } from '@mui/icons-material';
import ContentHeading from '../../../components/layout/content/ContentHeading';
import TableRowCommon from '../../../components/table/TableRowCommon';
import { dateTimeToView } from '../../../utils/date.utils';
import { NavigateFunction, useLocation, useNavigate, useParams } from 'react-router-dom';
import { ButtonBack, ButtonContained, ButtonPrimary } from '../../../components/button/ButtonCustoms';
import FilterSelect from '../../../components/select/filterSelect';
import { Box, MenuItem, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { CourseOfStudyApi } from '../../../api/course-of-study/course-of-study.api';
import { useDispatch } from 'react-redux';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';
import OptionsButtonCustom from '../../../components/button/OptionsButtonCustom';
import ModalCustom from '../../../components/modal/ModalCustom';
import FormComponent from '../../../components/gernerateForm/FormComponent';
import InputDatePicker from '../../../components/input/inputDatePicker';
import { degreeApi } from '../../../api/degree/degree.api';
import { facultyApi } from '../../../api/factulty/factulty.api';
import moment from 'moment';
import { alertActive, swalError, swalSuccess } from '../../../components/alert/swal';
import { routeName } from '../../../routes/routeName';
import { YearsApi } from '../../../api/yeas/years.api';
import FullCalendar from "@fullcalendar/react";
import timeGridPlugin from "@fullcalendar/timegrid";
import thLocale from '@fullcalendar/core/locales/th';
import { MyCourseOfStudyApi } from '../../../api/my-course-of-study/my-course-of-study.api';
import { useTranslation } from 'react-i18next';
import CustomStatus from '../../../components/chip/CustomStatus';
import { getEnumValue } from '../../../utils/common';
import { ADVISOR_ESTIMATE } from '../../../domains/enum/estimate';
import ContainerButton from '../../../components/button/ContainerButton';
import { getFileExtension } from '../../../utils/fileTypeDownload';
import saveAs from 'file-saver';

const days: any[] = [
    'ทุกวัน', // i18n-ignore: day filter value (compared with day_of_week_th), rendered with t
    "อาทิตย์", // i18n-ignore: day filter value (compared with day_of_week_th), rendered with t
    "จันทร์", // i18n-ignore: day filter value (compared with day_of_week_th), rendered with t
    "อังคาร", // i18n-ignore: day filter value (compared with day_of_week_th), rendered with t
    "พุธ", // i18n-ignore: day filter value (compared with day_of_week_th), rendered with t
    "พฤหัสบดี", // i18n-ignore: day filter value (compared with day_of_week_th), rendered with t
    "ศุกร์", // i18n-ignore: day filter value (compared with day_of_week_th), rendered with t
    "เสาร์", // i18n-ignore: day filter value (compared with day_of_week_th), rendered with t
];
const day: any[] = [
    "อาทิตย์", // i18n-ignore: day row label, rendered with t
    "จันทร์", // i18n-ignore: day row label, rendered with t
    "อังคาร", // i18n-ignore: day row label, rendered with t
    "พุธ", // i18n-ignore: day row label, rendered with t
    "พฤหัสบดี", // i18n-ignore: day row label, rendered with t
    "ศุกร์", // i18n-ignore: day row label, rendered with t
    "เสาร์", // i18n-ignore: day row label, rendered with t
];

const timeSlots = [
    "08:30 - 09:30",
    "09:30 - 10:30",
    "10:30 - 11:30",
    "11:30 - 12:30",
    "12:30 - 13:30",
    "13:30 - 14:30",
    "14:30 - 15:30",
    "15:30 - 16:30",
    "16:30 - 17:30",
    "17:30 - 18:30",
    "18:30 - 19:30",
];

export default function StudentsCourseOfStudyDetail() {
    // const currentYear = new Date().getFullYear() + 543; // ค.ศ. -> พ.ศ.
    // const years = Array.from({ length: 5 }, (_, i) => currentYear - i);

    const { id, id_academic_year } = useParams();
    const navigate: NavigateFunction = useNavigate();
    const location = useLocation()
    const [data, setData] = useState<any[]>([]);
    const [dateData, setDateData] = useState<any[]>([]);
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const [keyword, setKeyword] = useState<string>("");

    const [study_day, set_study_day] = useState<any>('ทุกวัน'); // i18n-ignore: day filter sentinel value
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("");
    const [sortType, setSortType] = useState<string>("ASC");
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy);
        setSortType(sortType);
    };
    const loadData = useCallback(async () => {
        dispatch(setLoading());

        try {
            // let condition: any = {};
            // if (page) condition = { ...condition, page: page };
            // if (pageLimit) condition = { ...condition, limit: pageLimit };

            const res = await MyCourseOfStudyApi.findById(id, id_academic_year);
            const data = res.data
            if (data?.status < 300) {
                setData(data.data?.map((item: any, index: number) => {
                    return {
                        ...item,
                        start_period: item?.start_period > 4 ? item?.start_period + 1 : item?.start_period,
                        end_period: item?.end_period > 4 ? item?.end_period + 1 : item?.end_period
                    }
                }));

                // setPage(data?.data?.meta.currentPage)
                setTotalItems(data?.data?.length)
                dispatch(unsetLoading());
            } else {
                dispatch(unsetLoading());
            }
        } catch (error) {
            dispatch(unsetLoading());
        }
    }, []);

    // useEffect(() => {
    //     fetchGetDegree()
    //     fetchGetFaculty()
    //     fetchGetYears()
    // }, [])
    useEffect(() => {
        loadData();
    }, [loadData]);

    const headCells = [
        {
            id: "#",
            width: '200px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: t("วัน"),
        },
        {
            id: "leave_type_name",
            width: '200px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: t("คาบ"),
        },
        {
            id: "leave_type_name",
            width: '200px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: t("ช่วงเวลา"),
        },
        {
            id: "status",
            disablePadding: false,
            width: '200px',
            sortable: false,
            align: "center",
            label: t("รหัสวิชา"),
        },
        {
            id: "status",
            disablePadding: false,
            width: '300px',
            sortable: false,
            align: "center",
            label: t("ชื่อรายวิชา"),
        },
        {
            id: "user_updated",
            disablePadding: false,
            align: "center",
            width: '250px',
            label: t("อาจารย์ผู้สอน"),
        },
        {
            id: "last_updated",
            disablePadding: false,
            align: "center",
            width: '100px',
            label: t("หน่วยกิต"),
        },
        {
            id: "leave_type_name",
            width: '200px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: t("วันที่เริ่มต้นเปิดให้ประเมิน"),
        },
        {
            id: "leave_type_name",
            width: '200px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: t("วันที่สิ้นสุดเปิดให้ประเมิน"),
        },
        {
            id: "status",
            disablePadding: false,
            width: 200,
            sortable: false,
            align: "start",
            label: t("สถานะ"),
        },
        {
            id: "action",
            disablePadding: false,
            align: "center",
            width: '80px',
            label: "action",
        },
    ];

    function isTodayInRange(
        startDate: string | Date,
        endDate: string | Date
    ): boolean {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const start = new Date(startDate);
        start.setHours(0, 0, 0, 0);

        const end = new Date(endDate);
        end.setHours(23, 59, 59, 999);

        return today >= start && today <= end;
    }

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1;
        const {
            day_of_week_th,
            start_period,
            start_at,
            end_at,
            courses_no,
            courses_name,
            instructors,
            credits,
            id_course_annual,
            estimate_start_date,
            estimate_end_date,
            estimate_time_status,
            estimate_status,
            seq
        } = objData;

        const objRenderData = {
            key: seq,
            id: no,
            obj: objData,
            columns: [
                {
                    option: "TEXT",
                    align: "center",
                    label: day_of_week_th ? t(day_of_week_th) : "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: start_period,
                },

                {
                    option: "TEXT",
                    align: "center",
                    label: (
                        `${start_at} - ${end_at}` || ''
                    ),
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: courses_no,
                },

                {
                    option: "TEXT",
                    align: "center",
                    label: (
                        courses_name || ''
                    ),
                },
                {
                    option: "TEXT",
                    align: "center",
                    disablePadding: true,
                    label: instructors[0]?.employee_name || '-'
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: credits,
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: estimate_start_date ? dateTimeToView(estimate_start_date) : '',
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: estimate_end_date ? dateTimeToView(estimate_end_date) : '',
                },
                {
                    option: "COMPONENT",
                    align: "start",
                    component: (
                        <CustomStatus
                            label={
                                t(getEnumValue(ADVISOR_ESTIMATE, estimate_status) ||
                                "Unknown status")
                            }
                            type="outlined"
                            color={
                                estimate_status === ADVISOR_ESTIMATE.OPEN_FOR_ESTIMATE ||
                                    estimate_status === ADVISOR_ESTIMATE.START_FOR_ESTIMATE
                                    ? "success"
                                    : estimate_status === ADVISOR_ESTIMATE.NOT_START_YET
                                        ? "warning"
                                        : "error"
                            }
                            icon={<FiberManualRecord />}
                            width="250px"
                        />
                    ),
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: (
                        <OptionsButtonCustom
                            enableView={isTodayInRange(estimate_start_date, estimate_end_date)}

                            onViewClick={() => {
                                navigate(routeName.students.CourseDetail.replace(':id', `${id}`) + `?id_course_annual=${id_course_annual}`)
                            }}
                        />
                    ),
                },
            ],
        };
        return <TableRowCommon {...objRenderData} />;
    };

    const handleDownloadFile = async () => {

        dispatch(setLoading());

        await MyCourseOfStudyApi.download(id, location?.state?.semester)
            .then((res) => {
                if (res.status < 300) {
                    const response = res.data;

                    // Get the content type from the server's response headers
                    const contentType = res.headers["content-type"];

                    // Create a Blob with the content type from the response
                    const blob = new Blob([response], { type: contentType });

                    // Extract file extension based on content type
                    const fileExtension = getFileExtension(contentType || "");

                    // Generate a filename with the correct extension (you can also modify this to use a custom name)
                    const fileName = `${"my-course-of-study" + new Date().getTime()
                        }.${fileExtension}`;

                    // Save the file
                    saveAs(blob, fileName);
                }
            })
            .catch((error) => console.log(error))
            .finally(() => dispatch(unsetLoading()));
    };
    return (
        <div>
            <ContentHeading
                title={t("ตารางเรียน ปีการศึกษา {{year}} ภาคเรียนที่ {{semester}}", { year: location?.state?.academic_year, semester: location?.state?.semester })}
                detail={t("กรุณาเลือกรายการที่ท่านต้องการ")}
            />
            {/* <div className='my-4'>
                {data?.length > 0 && <FullCalendar
                    plugins={[timeGridPlugin]}
                    initialView="timeGridWeek"
                    events={
                        dateData
                    }
                    allDaySlot={false}
                    locale={thLocale}
                    firstDay={0}
                    slotEventOverlap={true}
                    headerToolbar={false}
                    slotMinTime="08:30:00" // เริ่มตารางจาก 08:30
                    slotMaxTime="19:30:00"
                    slotLabelInterval={{ hours: 1 }} // ตั้งช่วงห่างของ label เป็น 1 ชั่วโมง
                    slotLabelFormat={{
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: false
                    }}
                    dayHeaderFormat={{
                        weekday: 'long'
                    }}
                    height="auto"
                // direction='rtl'
                />}
            </div> */}
            <div className='my-4'>
                <TableContainer component={Paper} >
                    <Table sx={{
                        minWidth: '1400px', '& .MuiTableCell-head': {
                            width: '150px',
                            padding: '14px 10px'
                        }
                    }}>
                        <TableHead>
                            <TableRow>
                                <TableCell align='center' sx={{ fontWeight: "bold", backgroundColor: "#555", color: "#fff !important" }}>{t('COUNRSE_OF_STUDT.PERIOD')}</TableCell>
                                <TableCell align='center' sx={{ fontWeight: "bold", backgroundColor: "#555", color: "#fff !important" }}>1</TableCell>
                                <TableCell align='center' sx={{ fontWeight: "bold", backgroundColor: "#555", color: "#fff !important" }}>2</TableCell>
                                <TableCell align='center' sx={{ fontWeight: "bold", backgroundColor: "#555", color: "#fff !important" }}>3</TableCell>
                                <TableCell align='center' sx={{ fontWeight: "bold", backgroundColor: "#555", color: "#fff !important" }}>4</TableCell>
                                <TableCell align='center' sx={{ fontWeight: "bold", backgroundColor: "#555", color: "#fff !important" }}>{t('COUNRSE_OF_STUDT.LUNCH_BREAK')}</TableCell>
                                <TableCell align='center' sx={{ fontWeight: "bold", backgroundColor: "#555", color: "#fff !important" }}>5</TableCell>
                                <TableCell align='center' sx={{ fontWeight: "bold", backgroundColor: "#555", color: "#fff !important" }}>6</TableCell>
                                <TableCell align='center' sx={{ fontWeight: "bold", backgroundColor: "#555", color: "#fff !important" }}>7</TableCell>
                                <TableCell align='center' sx={{ fontWeight: "bold", backgroundColor: "#555", color: "#fff !important" }}>8</TableCell>
                                <TableCell align='center' sx={{ fontWeight: "bold", backgroundColor: "#555", color: "#fff !important" }}>9</TableCell>
                                <TableCell align='center' sx={{ fontWeight: "bold", backgroundColor: "#555", color: "#fff !important" }}>10</TableCell>

                            </TableRow>
                        </TableHead>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ fontWeight: "bold", backgroundColor: "#f5f5f5" }}>{t("วัน/เวลา")}</TableCell>
                                {timeSlots.map((slot, index) => (
                                    <TableCell key={index} sx={{ fontWeight: "bold", backgroundColor: "#f5f5f5" }}>{slot}</TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {day.map((dayName, dayIndex) => {
                                let mergedCells = new Set();
                                return (
                                    <TableRow key={dayIndex}>
                                        <TableCell sx={{ fontWeight: "bold", backgroundColor: "#f5f5f5" }}>{t(dayName)}</TableCell>
                                        {/* <TableCell colSpan={11} >
                                            {data.filter(
                                                (c) => c.study_day === dayIndex)?.map((item: any, index: number) => {
                                                    console.log(item, index);
                                                    return (
                                                        <Table size="small">
                                                            <TableHead>
                                                                <TableRow>

                                                                    {[...Array(11)].map((_, i) => (
                                                                        <TableCell sx={{ padding: '0px !important', borderBottom: 'none !important' }}></TableCell>

                                                                    ))}
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                <TableRow>
                                                                    {timeSlots.map((_, timeIndex) => {
                                                                        if (mergedCells.has(timeIndex)) return null;

                                                                        const courses = data.filter(
                                                                            // (c) => c.study_day === dayIndex
                                                                            (c) => c.study_day === dayIndex && c.start_period === timeIndex + 1
                                                                        );

                                                                        console.log(courses);
                                                                        if (courses?.length > 0) {
                                                                            let maxColSpan = Math.max(...courses.map(c => c.end_period - c.start_period + 1));
                                                                            for (let i = 0; i < maxColSpan; i++) {
                                                                                mergedCells.add(timeIndex + i);
                                                                            }
                                                                            // console.log(maxColSpan);
                                                                            // let colSpan = item.end_period - item.start_period + 1;

                                                                            return (
                                                                                <TableCell key={timeIndex} colSpan={maxColSpan} >
                                                                                    <Table size="small">
                                                                                    <TableHead>
                                                                                        <TableRow>

                                                                                            {[...Array(maxColSpan)].map((_, i) => (
                                                                                                <TableCell sx={{ padding: '0px !important', borderBottom: 'none !important' }}></TableCell>

                                                                                            ))}
                                                                                        </TableRow>
                                                                                    </TableHead>
                                                                                    <TableBody>
                                                                                        {courses.map((course) => {
                                                                                            let colSpan = course.end_period - course.start_period + 1;
                                                                                            for (let i = 0; i < colSpan; i++) {
                                                                                                mergedCells.add(course.start_period - 1 + i);
                                                                                            }
                                                                                            return (
                                                                                                <TableRow key={course.id_course_annual}>
                                                                                                    <TableCell sx={{ borderBottom: 'none !important', padding: '0px !important', }} colSpan={colSpan}>
                                                                                                        <Box
                                                                                                            key={course.id_course_annual}
                                                                                                            onClick={() => navigate(routeName.students.CourseDetail.replace(':id', `${id}`) + `?id_course_annual=${course?.id_course_annual}`)}
                                                                                                            sx={{
                                                                                                                backgroundColor: course.color,
                                                                                                                color: "#fff",
                                                                                                                borderRadius: "8px",
                                                                                                                padding: "8px",
                                                                                                                textAlign: "left",
                                                                                                                cursor: 'pointer'
                                                                                                            }}
                                                                                                        >
                                                                                                            <strong>{course.courses_no}</strong><br />
                                                                                                            {course.courses_name}<br />
                                                                                                            {course.instructors.map((ins: any) => ins.employee_name).join(", ")}<br />
                                                                                                            {t("เวลา {{start}} - {{end}}", { start: course.start_at, end: course.end_at })}
                                                                                                        </Box>
                                                                                                    </TableCell>
                                                                                                    {[...Array(maxColSpan - colSpan)]?.map((x) => (
                                                                                                        <TableCell sx={{ borderBottom: 'none !important', }} />
                                                                                                    ))}
                                                                                                </TableRow>
                                                                                            )
                                                                                        })}
                                                                                    </TableBody>
                                                                                </Table>
                                                                                </TableCell>
                                                                            );
                                                                        }
                                                                        return <TableCell key={timeIndex}></TableCell>;
                                                                    })}
                                                                </TableRow>
                                                            </TableBody>
                                                        </Table>
                                                    )
                                                })}
                                        </TableCell> */}

                                        {timeSlots.map((_, timeIndex) => {
                                            if (mergedCells.has(timeIndex)) return null;

                                            const courses = data.filter(
                                                // (c) => c.study_day === dayIndex
                                                (c) => c.study_day === dayIndex && c.start_period === timeIndex + 1
                                            );

                                            if (courses.length > 0) {
                                                let maxColSpan = Math.max(...courses.map(c => c.end_period - c.start_period + 1));
                                                for (let i = 0; i < maxColSpan; i++) {
                                                    mergedCells.add(timeIndex + i);
                                                }
                                                return (
                                                    <TableCell key={timeIndex} colSpan={maxColSpan} >
                                                        <Table size="small">
                                                            <TableHead>
                                                                <TableRow>

                                                                    {[...Array(maxColSpan)].map((_, i) => (
                                                                        <TableCell sx={{ padding: '0px !important', borderBottom: 'none !important' }}></TableCell>

                                                                    ))}
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {courses.map((course) => {
                                                                    let colSpan = course.end_period - course.start_period + 1;
                                                                    for (let i = 0; i < colSpan; i++) {
                                                                        mergedCells.add(course.start_period - 1 + i);
                                                                    }
                                                                    return (
                                                                        <TableRow key={course.id_course_annual}>
                                                                            <TableCell sx={{ borderBottom: 'none !important', padding: '0px !important', }} colSpan={colSpan}>
                                                                                <Box
                                                                                    key={course.id_course_annual}
                                                                                    onClick={() => isTodayInRange(course?.estimate_start_date, course?.estimate_end_date) && navigate(routeName.students.CourseDetail.replace(':id', `${id}`) + `?id_course_annual=${course?.id_course_annual}`)}
                                                                                    sx={{
                                                                                        backgroundColor: course.color,
                                                                                        color: "#fff",
                                                                                        borderRadius: "8px",
                                                                                        padding: "8px",
                                                                                        textAlign: "left",
                                                                                        cursor: 'pointer'
                                                                                    }}
                                                                                >
                                                                                    <strong>{course.courses_no}</strong><br />
                                                                                    {course.courses_name}<br />
                                                                                    {course.instructors.map((ins: any) => ins.employee_name).join(", ")}<br />
                                                                                    {t("เวลา {{start}} - {{end}}", { start: course.start_at, end: course.end_at })}
                                                                                </Box>
                                                                            </TableCell>
                                                                            {[...Array(maxColSpan - colSpan)]?.map((x) => (
                                                                                <TableCell sx={{ borderBottom: 'none !important', }} />
                                                                            ))}
                                                                        </TableRow>
                                                                    )
                                                                })}
                                                            </TableBody>
                                                        </Table>

                                                    </TableCell>
                                                );
                                            }
                                            return <TableCell key={timeIndex}></TableCell>;
                                        })}

                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
            <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
                <article className="w-full col-span-12 md:col-span-4 lg:col-span-3 sm:col-span-12">
                    <InputTextField
                        startAdornment={<SearchOutlined />}
                        placeholder={t("ค้นหาชื่อวิชา/รหัสวิชา")}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            // handleChangeValueSearch("leave_type_name", e.target.value);
                            setKeyword(e.target.value)
                        }}
                        value={keyword || ''}
                    />
                </article>
                <article className="w-full col-span-12 md:col-span-4 lg:col-span-2 sm:col-span-12">
                    <FilterSelect
                        value={study_day || ""}
                        labelId="year-id"
                        selectId="year-select-id"
                        options={days.map((item: any, index: number) => (
                            <MenuItem value={item} key={index + 1}>
                                {t(item)}
                            </MenuItem>
                        ))}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            // handleChangeValueSearch("year", e.target.value)
                            set_study_day(e.target.value)
                        }}
                    />

                </article>
                <article className="w-full col-span-12 md:col-span-4 lg:col-span-7 sm:col-span-12">
                    <ContainerButton
                        justifyContent='flex-end'
                        buttonData={[

                            {
                                buttonProps: {
                                    onClick: () => {
                                        // setShowModal('ADD')
                                        handleDownloadFile()
                                    }
                                },
                                key: "DOWNLOAD_PDF",
                                label: t("TERM_PAYMENT_DOWNLOAD_PDF"),
                                seq: 3,
                                type: 'DOWNLOAD_PDF'
                            },

                        ]}
                    />
                </article>

            </div>

            <section className="w-full mt-10">
                <TableCustom
                    tableMinWidth={1440}
                    tableFixedWidth
                    customScroll
                    page={page}
                    pageLimit={pageLimit}
                    sortBy={sortBy}
                    sortType={sortType}
                    headCells={headCells}
                    rowCount={data.filter(
                        (item) =>
                            item.courses_no.toLowerCase().includes(keyword) ||
                            item.courses_name.toLowerCase().includes(keyword)
                    ).filter(
                        (item) =>
                            study_day !== 'ทุกวัน' ? item?.day_of_week_th.includes(study_day) : true // i18n-ignore: day filter sentinel value
                    ).length}
                    rowsData={
                        data.filter(
                            (item) =>
                                item.courses_no.toLowerCase().includes(keyword) ||
                                item.courses_name.toLowerCase().includes(keyword)
                        ).filter(
                            (item) =>
                                study_day !== 'ทุกวัน' ? item?.day_of_week_th.includes(study_day) : true // i18n-ignore: day filter sentinel value
                        )?.slice(
                            (page - 1) * pageLimit,
                            ((page - 1) * pageLimit) + pageLimit
                        ).map((list, index: number) => {
                            return {
                                ...list,
                                seq: page * pageLimit - pageLimit + index + 1
                            }
                        }).map((data: any, i: any) => {
                            return renderData(data, i);
                        })
                    }
                    onSort={handleRequestSort}
                    setPageLimit={(value: number) => setPageLimit(value)}
                    setPage={(value: number) => setPage(value)}
                />
            </section>

        </div>

    )
}
